import React from 'react'

export const Contact = () => {
  return (
     <section className="contact m-top m-btm" id='contact'>
               <iframe title="aus address" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3150.3857581821494!2d144.5916932153199!3d-37.85126337974556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad690096fd66a75%3A0x32f2fca68a507a5e!2s106%20Anniversary%20Ave%2C%20Wyndham%20Vale%20VIC%203024%2C%20Australia!5e0!3m2!1sen!2sin!4v1659007789176!5m2!1sen!2sin" width="60%" height="560"  loading="lazy"></iframe>
               <div className="container">
                      <form >
                      <span className='title'>Contact</span>
                      <h2>Have Questions? Get in Touch!</h2>
                          <div className="form-content">
                          <div className="flex space-btwn">
                              <div className="form-group">
                                 <label >First Name</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label >Last Name</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label >Email Id</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label >Phone Number</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label>Company Name</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label >Website Url</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label>When is the best time to contact you? *</label>
                                 <input type="text" />
                              </div>
                              <div className="form-group">
                                 <label>What is your city?(so we know your time zone) *</label>
                                 <input type="text" />
                              </div>
                            
                           </div>
                          </div>

                          <input type="submit" className="glbl-btn"/>
                      </form>
               </div>
     </section>
  )
}

